<template>
  <div class="my-2" data-test-id="student-create-apt-pass-form">
    <span class="text-black-50 text-value-lg mb-2 d-inline-block"
      >Departing From:</span
    >
    <LazyLoadSelect
      data-test-id="stu-apt-pass-fromid"
      v-model="form.from"
      :classes="[
        {
          'is-invalid': v$.form.from.$error || responseMessage.errors['from_id']
        }
      ]"
      :is-multiple="false"
      :selected="form.from"
      type="appointment"
      placeholder="Teacher/Location"
      @changed="
        (value) => {
          form.from = value
        }
      "
    >
      <template #footer>
        <div
          v-if="v$.form.$error && v$.form.from.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="responseMessage.errors['from_id']" class="invalid-feedback">
          {{ responseMessage.errors["from_id"][0] }}
        </div>
      </template>
    </LazyLoadSelect>

    <FavoriteCarousel
      :key="'departing'"
      :selected="v$.form.from.$model"
      :is-editable="true"
      :action="
        (elem) => {
          form.from = elem
        }
      "
      help-center-key="to_add_favorite_teacher_txt"
      :isvalid="checkIfValid('from')"
      class="mb-3"
      section="departing"
    />
    <hr />
    <span class="text-black-50 text-value-lg mb-2 d-inline-block"
      >Destination:</span
    >
    <LazyLoadSelect
      data-test-id="stu-apt-pass-toid"
      v-model="form.to"
      :classes="[
        { 'is-invalid': v$.form.to.$error || responseMessage.errors['to_id'] }
      ]"
      :is-multiple="false"
      :selected="form.to"
      type="appointment"
      placeholder="Teacher/Location"
      @changed="
        (value) => {
          onChangeEvent(value)
        }
      "
    >
      <template #footer>
        <div
          v-if="form.to && form.to.value && form.to.value.unavailability"
          class="invalid-feedback d-flex flex-wrap fw-bold"
        >
          This destination is unavailable until
          <span
            class="mx-1"
            v-html="
              $helpers.getHTMLDateTime(
                form.to.value.unavailability.to_date,
                'MMMM D, YYYY',
                'h:mm A'
              ) + '.'
            "
          />
          <span v-if="form.to.value.unavailability.comment"
            >Note: {{ form.to.value.unavailability.comment }}</span
          >
        </div>
        <div
          v-if="v$.form.$error && v$.form.to.required.$invalid"
          class="invalid-feedback"
        >
          This field is required
        </div>
        <div v-if="responseMessage.errors['to_id']" class="invalid-feedback">
          {{ responseMessage.errors["to_id"][0] }}
        </div>
      </template>
    </LazyLoadSelect>

    <FavoriteCarousel
      :key="'destination'"
      :selected="v$.form.to.$model"
      :is-editable="true"
      :show-unavailables="true"
      :action="
        (elem) => {
          onChangeEvent(elem)
        }
      "
      :isvalid="checkIfValid('to')"
      section="destination"
    />

    <CRow class="mt-3">
      <CCol sm="4" class="pe-3 pe-sm-1">
        <DatePicker
          data-test-id="stu-apt-pass-date"
          v-model="v$.form.for_date.$model"
          class="ap-cs-date-picker"
          placeholder="Date"
          :popover="{ visibility: 'click' }"
          :masks="{ input: 'MM/DD/YYYY' }"
          :min-date="minDate"
          @update:model-value="checkUnavailability"
        >
          <template #default="{ inputValue, togglePopover }">
            <div class="input-icon-field" @click="togglePopover">
              <div class="form-group">
                <input
                  class="form-control"
                  :class="{
                    'is-invalid':
                      v$.form.for_date.$error ||
                      responseMessage.errors['for_date']
                  }"
                  placeholder="Date"
                  readonly
                  :value="inputValue"
                />
                <div
                  v-if="v$.form.$error && v$.form.for_date.required.$invalid"
                  class="invalid-feedback"
                >
                  This field is required
                </div>
                <div
                  v-if="responseMessage.errors['for_date']"
                  class="invalid-feedback"
                >
                  {{ responseMessage.errors["for_date"][0] }}
                </div>
              </div>
              <span class="field-icon">
                <i class="fi flaticon-calendar me-1" />
              </span>
            </div>
          </template>
        </DatePicker>
      </CCol>
      <CCol sm="4">
        <VSelect
          data-test-id="stu-apt-pass-period"
          v-model="form.period"
          :options="periods"
          placeholder="Period"
          :clearable="false"
          class="cs-select periods ps__child--consume"
          :class="{
            'is-invalid':
              v$.form.period.$error || responseMessage.errors['period_id']
          }"
          lable="label"
        >
          <template #footer>
            <div v-if="v$.form.period.$error" class="invalid-feedback">
              This field is required
            </div>
            <div
              v-if="responseMessage.errors['period_id']"
              class="invalid-feedback"
            >
              {{ responseMessage.errors["period_id"][0] }}
            </div>
          </template>
        </VSelect>
      </CCol>
      <CCol sm="4" class="ps-3 ps-sm-0 my-3 my-sm-0">
        <CustomTimePicker
          format="HH:mm"
          data-test-id="stu-apt-pass-time"
          v-model="v$.form.time.$model"
          placeholder="Time"
          @update:model-value="checkUnavailability"
          :class="{
            'is-invalid': !!(
              v$.form.time.$error || responseMessage.errors['time']
            )
          }"
        >
          <template #footer>
            <div
              v-if="v$.form.$error && v$.form.time.required.$invalid"
              class="invalid-feedback"
            >
              This field is required
            </div>
            <div
              v-if="
                v$.form.$error &&
                !v$.form.time.required.$invalid &&
                v$.form.time.minTime.$invalid
              "
              class="invalid-feedback"
            >
              The time must be 30 minutes from now and not more than a month!
            </div>
            <div
              v-if="
                v$.form.$error &&
                !v$.form.time.required.$invalid &&
                v$.form.time.betweenTime.$invalid
              "
              class="invalid-feedback"
            >
              You must pick a time between 6AM and 5PM.
            </div>
            <div v-if="responseMessage.errors['time']" class="invalid-feedback">
              {{ responseMessage.errors["time"][0] }}
            </div>
          </template>
        </CustomTimePicker>
      </CCol>
    </CRow>

    <textarea
      class="form-control"
      maxlength="250"
      data-test-id="stu-apt-pass-comment"
      v-if="
        form &&
        form.to &&
        form.to.value &&
        form.to.value.comment_type != 'Hidden'
      "
      :placeholder="
        form.to.value.comment_type == 'Optional'
          ? 'Reason for pass (optional)'
          : 'Reason for pass (required)'
      "
      rows="5"
      :class="{
        'is-invalid':
          (v$.form.$error && v$.form.reason.$invalid) ||
          responseMessage.errors['comment']
      }"
      v-model="v$.form.reason.$model"
    />
    <div
      v-if="
        form &&
        form.to &&
        form.to.value &&
        form.to.value.comment_type != 'Hidden'
      "
      class="text-end mt-1"
    >
      250 characters max
    </div>
    <div
      v-if="v$.form.$error && v$.form.reason.mandatory.$invalid"
      class="invalid-feedback"
    >
      This field is required
    </div>
    <div v-if="responseMessage.errors['reason']" class="invalid-feedback">
      {{ responseMessage.errors["reason"][0] }}
    </div>

    <CAlert
      data-test-id="stu-apt-pass-form-error"
      v-if="
        responseMessage.message &&
        responseMessage.message !== 'The given data was invalid.'
      "
      class="mt-3"
      :color="responseMessage.type"
      :show="!!responseMessage.message"
    >
      {{ responseMessage.message }}
    </CAlert>

    <div class="form-group form-actions mt-2 text-center">
      <div
        data-test-id="create-apt-pass-form-submit"
        class="d-inline"
        @click="submit()"
      >
        <CLoadingButton
          :spinner="isLoading"
          :disabled="isLoading"
          :loading="isLoading"
          class="mt-2 btn bg-gradient-blue text-white"
        >
          Submit
        </CLoadingButton>
      </div>
    </div>
    <CModal
      backdrop="static"
      :visible="showAppPassSuccesModal"
      add-content-classes="bg-white"
    >
      <div class="d-flex">
        <h2 class="mb-0 text-center text-black-50 w-100 pt-4">
          Appointment Request Sent for
          {{ $helpers.currTzDate(form.for_date, "ddd, M/D") }}
        </h2>
      </div>

      <div class="d-flex w-50 my-2 mx-auto">
        <button
          data-test-id="stu-create-apt-pass-btn"
          class="btn btn-confirm w-100 m-2 p-3"
          @click="
            () => {
              showAppPassSuccesModal = false
              $router.push('/appointments')
            }
          "
        >
          Apt Menu
        </button>
        <button
          class="btn btn-cancel w-100 m-2 p-3"
          @click="closePassSuccess()"
        >
          Close
        </button>
      </div>
    </CModal>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"
import FavoriteCarousel from "@/v3components/FavoriteCarousel.vue"
import moment from "moment-timezone"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"

export default {
  name: "CreateAppointmentPassForm",
  components: {
    FavoriteCarousel,
    LazyLoadSelect
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      form: {
        from: [],
        to: [],
        reason: "",
        for_date: null,
        time: null
      },
      responseMessage: {
        type: "",
        message: "",
        errors: []
      },
      showAppPassSuccesModal: false,
      requestIntreval: null
    }
  },
  validations: {
    form: {
      from: {
        required
      },
      to: {
        required
      },
      reason: {
        mandatory: (value, vm) => {
          if (
            vm.to &&
            vm.to.value &&
            vm.to.value.comment_type &&
            vm.to.value.comment_type == "Mandatory"
          ) {
            if (vm.reason && vm.reason != "") {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        }
      },
      time: {
        required,
        minTime: (value, vm) => {
          if (
            vm.for_date &&
            vm.time &&
            moment()
              .add(30, "minutes")
              .isSameOrBefore(
                moment(
                  moment(
                    new Date(vm.for_date).toLocaleDateString("en-GB"),
                    "DD-MM-YYYY"
                  ).format("YYYY-MM-DD") +
                    " " +
                    vm.time
                )
              )
          ) {
            return true
          } else {
            return false
          }
        },
        betweenTime: (value, vm) => {
          return moment(vm.time, "HH:mm a").isBetween(
            moment("05:59 AM", "HH:mm a"),
            moment("05:01 PM", "HH:mm a")
          )
        }
      },
      for_date: {
        required
      },
      period: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({
      periods: "passes/formListPeriods"
    }),
    isValid() {
      return !this.v$.form.$invalid
    },
    minDate() {
      return moment().format("MMM DD YYYY")
    }
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.v$.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || field.$model === "")
    },
    onChangeEvent(value) {
      this.form.to = value
      this.checkUnavailability()
    },
    checkUnavailability() {
      if (!this.form.to?.value || !this.form.for_date || !this.form.time) {
        this.form.to?.value && this.form.to.value.unavailability == null
        return
      }
      clearTimeout(this.requestIntreval)
      this.requestIntreval = setTimeout(() => {
        const params = {
          type: this.form.to.value.type,
          id: this.form.to.value.id,
          apt_for_time: this.$helpers.currTzDateTime(
            this.form.for_date,
            this.form.time
          )
        }
        this.$store
          .dispatch("rooms/getUnavailability", params)
          .then((response) => {
            if (response.data.data) {
              this.form.to.value.unavailability = response.data.data
            } else {
              this.form.to.value.unavailability = null
            }
          })
          .catch(() => {
            this.form.to.value.unavailability = null
          })
      }, 600)
    },
    submit() {
      this.resetResponseMessage()
      this.isLoading = true
      if (this.isValid) {
        const appointmentPass = {
          from_id: this.form.from.value.id,
          to_id: this.form.to.value.id,
          from_type: this.form.from.value.type,
          to_type: this.form.to.value.type,
          for_date: this.$helpers.currTzDateTime(
            this.form.for_date,
            this.form.time
          ),
          time: this.$helpers.currTzDateTime(
            this.form.for_date,
            this.form.time
          ),
          reason: this.form.reason,
          period_id: this.form.period.value[0]
        }

        this.$store
          .dispatch(
            "studentAptPass/createStudentAppointmentPass",
            appointmentPass
          )
          .then(() => {
            this.isLoading = false
            this.showAppPassSuccesModal = true
          })
          .catch((err) => {
            this.responseMessage = {
              type: "danger",
              message: err.response.data.message,
              errors: err.response.data.errors ? err.response.data.errors : []
            }
            this.isLoading = false
          })
      } else {
        this.v$.$touch()
        this.isLoading = false
      }
    },
    closePassSuccess() {
      this.showAppPassSuccesModal = false
      this.form = {
        from: [],
        to: [],
        reason: "",
        for_date: null,
        time: null
      }
      this.v$.$reset()
      window.location.reload()
    },
    resetResponseMessage() {
      this.responseMessage = {
        type: "",
        message: "",
        errors: []
      }
    }
  }
}
</script>

<style scope lang="scss">
.periods {
  #vs5__listbox {
    max-height: 110px !important;
  }
}
.ap-cs-date-picker .input-icon-field .form-control.is-invalid {
  pointer-events: auto;
  // margin-bottom: 7rem !important;
}
</style>
